import { Navigate } from "react-router-dom";

export default function RolesTab() {
  return <Navigate to="/admin-users" replace />;
}
